import { Link } from 'react-router-dom';
import { GovBreadcrumbs } from '@gov-design-system-ce/react/gov-breadcrumbs';
import { GovIcon } from '@gov-design-system-ce/react/gov-icon';
import { useGlobalLocale } from '@gov-nx/core/service/translations/useGlobalLocale';
import type { ServiceCode } from '@gov-nx/module/service/definitions/codes';
import {
	isFirstIndex,
	isLastIndex,
} from '@gov-nx/utils/common/Array/indexPositions';
import type { PagePath } from '@gov-nx/web/Router/helpertypes';
import {
	pageRouteResolver,
	serviceRouteResolver,
} from '@gov-nx/web/Router/routeResolver';

export type BreadcrumbOption = { label: string } & (
	| { toPage: PagePath; toService?: never }
	| { toService: keyof typeof ServiceCode; toPage?: never }
	| { toPage?: never; toService?: never }
);

export const Breadcrumbs = ({ options }: { options: BreadcrumbOption[] }) => {
	const { t } = useGlobalLocale();

	return (
		<GovBreadcrumbs aria-label={t('drobeckova-navigace.wcag.label')}>
			<ul className="gov-list--plain">
				{options.map((option, i) => {
					const isFirst = isFirstIndex(i);
					const isLast = isLastIndex(i, options);
					const to = option.toPage
						? pageRouteResolver(option.toPage)
						: option.toService
							? serviceRouteResolver(option.toService)
							: '#';
					return (
						<li key={option.label}>
							{!isFirst ? (
								<GovIcon
									name="chevron-right"
									type="components"
								/>
							) : null}
							{isLast ? (
								<strong className="wrap-anywhere hyphens-auto">
									{option.label}
								</strong>
							) : (
								<Link
									to={to}
									className="ml-0.5!">
									{option.label}
								</Link>
							)}
						</li>
					);
				})}
			</ul>
		</GovBreadcrumbs>
	);
};
